'use strict';

import baseApi from './base-api';

export default class ProductApi extends baseApi {  
  getProduct(productSid) {
    return this.getApiRequest(`/products/${productSid}`);
  }
}